/* eslint-disable jsx-a11y/alt-text */
import {
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import i18n from "i18next";
import { useDispatch } from "react-redux";
import { useSettings } from "../../../../contexts/use-settings";
import {
  setCountryCode,
  setLanguage,
} from "../../../../redux/slices/configData";
import { TopBarButton } from "../../NavBar.style";
import { languageList } from "./languageList";

const getValues = (settings) => ({
  direction: settings.direction,
  responsiveFontSizes: settings.responsiveFontSizes,
  theme: settings.theme,
});

const CustomLanguage = ({
  formmobilemenu,
  language,
  countryCode,
  noPaddingRight,
  noText,
}) => {
  const theme = useTheme();
  const { settings, saveSettings } = useSettings();
  const [values, setValues] = useState(getValues(settings));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedLanguage = localStorage.getItem("language-setting");
      const storedCountry = localStorage.getItem("country");
      if (storedLanguage && storedCountry) {
        const lang = JSON.parse(storedLanguage);
        const country = JSON.parse(storedCountry);
        dispatch(setLanguage(lang));
        dispatch(setCountryCode(country));
        i18n.changeLanguage(lang);
        const currentLang = languageList.find(item => item.languageCode === lang);
        if (currentLang) {
          saveSettings({
            ...values,
            direction: currentLang.direction,
          });
        }
      } else {
        // Set English as default
        localStorage.setItem("language-setting", JSON.stringify("en"));
        localStorage.setItem("country", JSON.stringify("US"));
        dispatch(setLanguage("en"));
        dispatch(setCountryCode("US"));
        i18n.changeLanguage("en");
        saveSettings({
          ...values,
          direction: "ltr",
        });
      }
    }
  }, []);

  useEffect(() => {
    settings && setValues(getValues(settings));
  }, [settings]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    localStorage.setItem("language-setting", JSON.stringify(lang.languageCode));
    localStorage.setItem("country", JSON.stringify(lang.countryCode));
    dispatch(setLanguage(lang.languageCode));
    dispatch(setCountryCode(lang.countryCode));
    i18n.changeLanguage(lang.languageCode);
    saveSettings({
      ...values,
      direction: lang.direction,
    });
    handleClose();
  };

  // Safe fallback to English if language is not yet defined
  const fallbackLang = languageList.find((item) => item.languageCode === "en") || languageList[0];
  const currentLanguage =
    languageList.find((item) => item.languageCode === language) || fallbackLang;

  return (
    <>
      <TopBarButton
        formmobilemenu={formmobilemenu}
        variant="text"
        size="small"
        disableElevation
        onClick={handleClick}
        sx={{
          paddingRight: noPaddingRight && "0px",
        }}
        startIcon={
          currentLanguage && (
            <Stack color={theme.palette.neutral[1000]}>
              <img 
                src={currentLanguage.countryFlag} 
                alt={currentLanguage.languageName}
                style={{
                  width: '20px',
                  height: '15px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '2px',
                  objectFit: 'cover'
                }}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = fallbackLang.countryFlag;
                }}
              />
            </Stack>
          )
        }
      >
        {!noText && (
          <Typography color={theme.palette.neutral[1000]}>
            {currentLanguage?.languageName}
          </Typography>
        )}
      </TopBarButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {languageList.map((lang, index) => (
          <MenuItem
            key={index}
            onClick={() => handleLanguageChange(lang)}
            selected={lang.languageCode === language}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <img 
                src={lang.countryFlag} 
                alt={lang.languageName} 
                width="20"
                style={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '2px'
                }}
              />
              <Typography>{lang.languageName}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

CustomLanguage.propTypes = {};

export default CustomLanguage;
